export default "/images/Device_simulador.png?307a56ff6d8d541dddd68198e258066a";